var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 10.834C10.4576 10.834 10.8307 10.4609 10.8307 10.0007C10.8307 9.54041 10.4576 9.16732 9.9974 9.16732C9.53716 9.16732 9.16406 9.54041 9.16406 10.0007C9.16406 10.4609 9.53716 10.834 9.9974 10.834Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 5.00065C10.4576 5.00065 10.8307 4.62755 10.8307 4.16732C10.8307 3.70708 10.4576 3.33398 9.9974 3.33398C9.53716 3.33398 9.16406 3.70708 9.16406 4.16732C9.16406 4.62755 9.53716 5.00065 9.9974 5.00065Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 16.6673C10.4576 16.6673 10.8307 16.2942 10.8307 15.834C10.8307 15.3737 10.4576 15.0007 9.9974 15.0007C9.53716 15.0007 9.16406 15.3737 9.16406 15.834C9.16406 16.2942 9.53716 16.6673 9.9974 16.6673Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDot);
export default __webpack_public_path__ + "static/media/threeDot.7b5f0192336e73ffe31be15eaa56e458.svg";
export { ForwardRef as ReactComponent };